/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserAsSuperAdminDto } from '../../models/set-user-as-super-admin-dto';

export interface SuperAdminsControllerSetAsSuperAdmin$Params {

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
      body: SetUserAsSuperAdminDto
}

export function superAdminsControllerSetAsSuperAdmin(http: HttpClient, rootUrl: string, params: SuperAdminsControllerSetAsSuperAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, superAdminsControllerSetAsSuperAdmin.PATH, 'post');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

superAdminsControllerSetAsSuperAdmin.PATH = '/api/v1/users/super-admins';
